import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      const releaseId = process.env.REACT_APP_RELEASE_ID || 'local';
      const publicUrl = process.env.PUBLIC_URL || '';
      const serviceWorkerBaseUrl = publicUrl.endsWith('/') ? publicUrl.slice(0, -1) : publicUrl;
      navigator.serviceWorker
        .register(`${serviceWorkerBaseUrl}/service-worker.js?release=${encodeURIComponent(releaseId)}`, {
          updateViaCache: 'none',
        })
        .catch(() => {});
    });
  } else {
    navigator.serviceWorker.getRegistrations?.().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }
}
